var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _path10, _path11, _path12, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModuleLibraryCardPlaceholderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.43,
    fill: "#FFEEEB",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.441 21.145v-1.112a4.538 4.538 0 0 0-4.523-4.523 3.067 3.067 0 0 0-.49.033 4.536 4.536 0 0 0-4.033 4.49v6.052h8.165l.881-4.94z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.561 26.685H19.184a.6.6 0 0 1-.6-.6v-4.946a6.186 6.186 0 0 1 1.83-4.4 6.312 6.312 0 0 1 5.07-1.8 6.229 6.229 0 0 1 5.556 6.194l-1.2.007v-.007a5.026 5.026 0 0 0-5.029-5.03 5.053 5.053 0 0 0-5.029 5.029v4.347h9.778l.001 1.206z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.435 11.484a4.736 4.736 0 1 0 8.751-3.623 4.736 4.736 0 0 0-8.75 3.623zm.839-1.81a3.537 3.537 0 1 1 7.074 0 3.537 3.537 0 0 1-7.074 0zM29.545 26.761H43.1a.6.6 0 0 0 .592-.489l1.786-10a.6.6 0 0 0-.591-.705H31.33a.6.6 0 0 0-.591.494l-1.785 10a.6.6 0 0 0 .59.7zm13.055-1.2H30.26l1.572-8.8H44.17l-1.57 8.8z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 30.258h45.75a.6.6 0 0 0 .6-.6v-3.5a.6.6 0 0 0-.6-.6H1a.6.6 0 0 0-.6.6v3.5a.6.6 0 0 0 .6.6zm45.15-1.199H1.6v-2.3h44.55v2.3z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.86 45.044a.6.6 0 0 1-.6-.6V32.372a.6.6 0 1 1 1.2 0v12.072a.6.6 0 0 1-.6.6zM7.891 45.044a.6.6 0 0 1-.6-.6V29.658a.6.6 0 1 1 1.2 0v14.786a.6.6 0 0 1-.6.6z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45.044H1.249a.6.6 0 1 1 0-1.2h45.75a.6.6 0 1 1 0 1.2z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.24 38.971a5.018 5.018 0 1 0 9.272-3.84 5.018 5.018 0 0 0-9.272 3.84zm.818-1.919a3.818 3.818 0 1 1 7.636 0 3.818 3.818 0 0 1-7.636 0z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.89 40.043a.6.6 0 0 1-.6-.6v-2.477a.6.6 0 1 1 1.2 0v2.478a.6.6 0 0 1-.6.599z",
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.876,
    cy: 35.249,
    r: 0.589,
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.477 12.493A5.86 5.86 0 1 0 13.305 8.01a5.86 5.86 0 0 0-10.828 4.484zm.753-2.241a4.661 4.661 0 1 1 9.322 0 4.661 4.661 0 0 1-9.322 0z",
    fill: "#000000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.041 13a.6.6 0 0 1-.424-.176L7.291 10.5V6.943a.6.6 0 1 1 1.2 0V10l1.975 1.976A.6.6 0 0 1 10.041 13z",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22 26.683h5.236a.64.64 0 0 0 .6-.645 3.218 3.218 0 1 0-6.436.045.6.6 0 0 0 .6.6zm4.554-1.199H9.9a2.013 2.013 0 0 1 3.874 0z",
    fill: "#000000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.838 24.02a.6.6 0 0 1-.6-.6v-.52a.6.6 0 0 1 1.2 0v.521a.6.6 0 0 1-.6.599z",
    fill: "#000000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.216,
    cy: 21.16,
    r: 1.617,
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleLibraryCardPlaceholderIcon);
export default __webpack_public_path__ + "static/media/module-library-card-placeholder-icon.ee4781ba163e7226a2a3f2b3b0b36cae.svg";
export { ForwardRef as ReactComponent };